module.exports = __webpack_public_path__ + "static/media/ser_sit_spe_met.86a648c9.png";